<template>
  <div style="overflow:hidden">
    <NewsBanner :imageList="this.config.banner_top.imageList"></NewsBanner>
    <NewsTitle></NewsTitle>
    <NewsContent></NewsContent>
    <NewsBanner3></NewsBanner3>
  </div>
</template>

<script>
import NewsBanner from "@/yintai/view/content/news/NewsBanner.vue";
import NewsTitle from "@/yintai/view/content/news/NewsTitle.vue";
import NewsContent from "@/yintai/view/content/news/NewsContent.vue";
import NewsBanner3 from "@/yintai/view/content/news/NewsBanner3.vue";
import { fetchConfig } from "@/yintai/api/config";

export default {
  name: "about",
  components: {
    NewsBanner,
    NewsTitle,
    NewsContent,
    NewsBanner3,
  },
  data() {
    return {
      config: {
        banner_top: {
          imageList: [],
        },
      },
    };
  },
  async mounted() {
    const response = await fetchConfig({ id: 8 });
    this.config = response.data.data.item.config;
  },
  methods: {},
};
</script>
